import React, { PropsWithChildren, PureComponent } from 'react';
import { StaticMap, StaticMapProps } from 'react-map-gl';
import styled from 'styled-components';
import { MAPBOX_TOKEN } from '../../config/index';
import { streets } from './MapStyle';

const StyledStaticMap = styled(StaticMap).withConfig({ componentId: 'sc-5vjkjg-0' })<PropsWithChildren<StaticMapProps>>`
  .mapboxgl-canvas {
    left: 0; // https://github.com/uber/react-map-gl/issues/604
  }
`;

type OwnProps = {
  latLong: any;
  width: number;
  height: number;
  zoom?: number;
  className?: string;
};

type Props = OwnProps & typeof SMap.defaultProps;

class SMap extends PureComponent<Props> {
  static defaultProps = {
    zoom: 8,

    children: <></>,
  };

  render() {
    const { latLong, zoom, width, height, className, children } = this.props;
    const latitude = parseFloat(latLong.latitude);
    const longitude = parseFloat(latLong.longitude);
    return (
      <StyledStaticMap
        attributionControl={false}
        className={className}
        height={height}
        latitude={latitude}
        longitude={longitude}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        mapStyle={streets}
        width={width}
        zoom={zoom}
      >
        {children}
      </StyledStaticMap>
    );
  }
}

export default SMap;
